import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static targets = ["list", "moreButton"]
  static values = { url: String, page: Number }

  connect() {
  }

  disconnect() {
  }

  async loadMore(event) {
    event.preventDefault()
    
    if (this.hasMoreButtonTarget) {
      // ボタンをローディング状態にする
      const button = this.moreButtonTarget
      button.innerHTML = '<i class="fas fa-spinner fa-spin mr-2"></i>読み込み中...'
      button.disabled = true
    }

    try {
      // 現在のスクロール位置を保存
      const currentScrollY = window.scrollY
      
      // 現在のURLパラメータを取得
      const currentUrl = new URL(window.location)
      const searchParams = currentUrl.searchParams
      
      // ページ番号を追加
      searchParams.set('page', this.pageValue)
      
      // Turbo Streamリクエストを送信
      const response = await fetch(`${this.urlValue}?${searchParams.toString()}`, {
        headers: {
          'Accept': 'text/vnd.turbo-stream.html',
          'X-Requested-With': 'XMLHttpRequest'
        }
      })

      if (response.ok) {
        const turboStream = await response.text()
        
        if (turboStream.trim()) {
          // Turbo Streamを処理
          Turbo.renderStreamMessage(turboStream)
          
          // ページ番号を増加
          this.pageValue += 1
          
          // スクロール位置を復元
          setTimeout(() => {
            window.scrollTo(0, currentScrollY)
          }, 100)
          
          // ボタンを元に戻す
          if (this.hasMoreButtonTarget) {
            const button = this.moreButtonTarget
            button.innerHTML = '<span>もっと見る</span><i class="fas fa-chevron-down"></i>'
            button.disabled = false
          }
        } else {
          // これ以上データがない場合はボタンを隠す
          if (this.hasMoreButtonTarget) {
            this.moreButtonTarget.style.display = 'none'
          }
        }
      } else {
        console.error('Failed to load more content:', response.status)
        // エラー時はボタンを元に戻す
        if (this.hasMoreButtonTarget) {
          const button = this.moreButtonTarget
          button.innerHTML = '<span>もっと見る</span><i class="fas fa-chevron-down"></i>'
          button.disabled = false
        }
      }
    } catch (error) {
      console.error('Error loading more content:', error)
      // エラー時はボタンを元に戻す
      if (this.hasMoreButtonTarget) {
        const button = this.moreButtonTarget
        button.innerHTML = '<span>もっと見る</span><i class="fas fa-chevron-down"></i>'
        button.disabled = false
      }
    }
  }
}
